import React from "react";
import { Navigate, redirect, useNavigate } from "react-router-dom";
import { actionGetForgotPass } from "../../features/login-forgot/slices";
import Button from "../../components/Button";
import Input from "../../components/Inputs";
import "../PageLogin/_styles.scss";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
// @ts-ignore: Allow importing image asset without type declaration
import IkoneLogo from "../../assets/ikone.png";
import { toast } from "sonner";
import { getUser, logout } from "../../helpers/user";
import { Eye, EyeOff } from "lucide-react";
import { InputChange } from "../../global/type";

interface IStatePageForgotPass {
  login: string;
  email: string;
  novaSenha?: "";
  confirmSenha?: "";
}

const PageForgotPass = () => {
  const dispatch = useAppDispatch();
  const { status } = useAppSelector((state) => state.getForgotPass);
  const navegate = useNavigate();

  const initialState: IStatePageForgotPass = {
    login: "",
    email: "",
    novaSenha: "",
    confirmSenha: "",
  };

  const [state, setState] = React.useState(initialState);
  const [isLogged, setIsLogged] = React.useState<null | boolean>(null);
  const [showSenha, setShowSenha] = React.useState(false);
  const [showConfirmSenha, setShowConfirmSenha] = React.useState(false);

  const handlerForgotPass = async (ev: React.FormEvent<HTMLInputElement>) => {
    ev.preventDefault();

    if (isLogged) {
      if (state.novaSenha === "" || state.confirmSenha === "") {
        toast.error("Preencha todos os campos");
        return;
      }

      if (state.novaSenha !== state.confirmSenha) {
        toast.error("Senhas diferentes");
        return;
      }
    } else {
      if (state.login === "" || state.email === "") {
        toast.error("Preencha todos os campos");
        return;
      }

      if (state.novaSenha !== state.confirmSenha) {
        toast.error("As senhas não coincidem");
        return;
      }

      if (
        !state.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
      ) {
        toast.error("Email inválido");
        return;
      }
    }

    console.log("Clicado");

    try {
      await dispatch(actionGetForgotPass(state));

      if (!isLogged) {
        if (status === "success") {
          setTimeout(() => {
            navegate("/Ativar-acesso");
          }, 2000);
        }
      }
    } catch (error: any) {
      console.error("Falha na solicitação de nova senha:", error);
      toast.error(error.message || "Não foi possível completar a solicitação.");
    }
  };

  const handlerChange = (ev: InputChange) => {
    const { name, value } = ev.currentTarget;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handlerCancelar = (ev: InputChange) => {
    ev.preventDefault();
    navegate("/");
  };

  React.useEffect(() => {
    if (status === "success") {
      if (isLogged) {
        setTimeout(() => logout(), 2000);
      }
    }
  }, [status, isLogged]);

  React.useEffect(() => {
    try {
      const user = getUser();
      if (!user) {
        setIsLogged(false);
        return;
      }
      const { token } = user;
      setIsLogged(!!token);
    } catch (err) {
      console.error("Erro ao buscar usuário:", err);
      setIsLogged(false);
    }
  }, []);

  if (isLogged === null) return null;

  if (isLogged)
    return (
      <div className="page-login">
        <form className="form-login">
          <h1 className="text-center heading--md mb-10">Alterar Senha</h1>
          <div style={{ position: "relative" }}>
            <Input
              type={showSenha ? "text" : "password"}
              name="novaSenha"
              label="Nova Senha"
              size="sm"
              placeholder=""
              onChange={handlerChange}
            />
            <span
              onClick={() => setShowSenha((prev) => !prev)}
              style={{
                position: "absolute",
                top: "55%",
                right: "1rem",
                cursor: "pointer",
              }}
            >
              {showSenha ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>

          <div style={{ position: "relative", marginTop: "1rem" }}>
            <Input
              type={showConfirmSenha ? "text" : "password"}
              name="confirmSenha"
              label="Confirmar Senha"
              size="sm"
              placeholder=""
              onChange={handlerChange}
            />
            <span
              onClick={() => setShowConfirmSenha((prev) => !prev)}
              style={{
                position: "absolute",
                top: "55%",
                right: "1rem",
                cursor: "pointer",
              }}
            >
              {showConfirmSenha ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              marginTop: "1rem",
            }}
          >
            <Button
              size="sm"
              variant="primary"
              onClick={handlerForgotPass}
              loading={status === "loading"}
            >
              Confirmar
            </Button>
            <Button size="sm" variant="secondary" onClick={handlerCancelar}>
              Cancelar/Voltar
            </Button>
          </div>
        </form>

        <div className="page-login__footer">
          <p>desenvolvido por</p>
          <img src={IkoneLogo} alt="Logotipo da Ikone" />
        </div>
      </div>
    );

  return (
    <div className="page-login">
      <form className="form-login">
        <h1 className="text-center heading--md mb-10">Esqueci a Senha</h1>
        <div className="form-login__inputs">
          <Input
            type="text"
            name="login"
            label="Nome"
            size="sm"
            placeholder=""
            onChange={handlerChange}
          />
          <Input
            type="text"
            name="email"
            label="Email"
            size="sm"
            placeholder=""
            onChange={handlerChange}
          />
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            size="sm"
            variant="primary"
            onClick={handlerForgotPass}
            loading={status === "loading"}
          >
            Enviar Chave
          </Button>
          <Button size="sm" variant="secondary" onClick={handlerCancelar}>
            Cancelar/Voltar
          </Button>
        </div>
      </form>

      <div className="page-login__footer">
        <p>desenvolvido por</p>
        <img src={IkoneLogo} alt="Logotipo da Ikone" />
      </div>
    </div>
  );
};

export default PageForgotPass;
